// extracted by mini-css-extract-plugin
export default {"tags":"src-components-TagGroup-css__tags--keIjL","grayTags":"src-components-TagGroup-css__grayTags--+I5h8","wrappedTags":"src-components-TagGroup-css__wrappedTags--Dc3sI"};